<div class="border-round border-1 surface-border p-4 surface-card">
  <div class="d-flex mb-3">
    <p-skeleton
      shape="circle"
      size="4rem"
      styleClass="me-2"></p-skeleton>
    <div>
      <p-skeleton
        styleClass="mb-2"
        width="10rem"></p-skeleton>
      <p-skeleton
        styleClass="mb-2"
        width="5rem"></p-skeleton>
      <p-skeleton height=".5rem"></p-skeleton>
    </div>
  </div>
  <p-skeleton
    height="150px"
    width="100%"></p-skeleton>
  <div class="d-flex justify-content-between mt-3">
    <p-skeleton
      height="2rem"
      width="4rem"></p-skeleton>
    <p-skeleton
      height="2rem"
      width="100%"></p-skeleton>
  </div>
</div>
